import requestAction from '../../utils/requestAction'
import Goal from '../../models/Goal';

export const upsertGoal = (goal: Goal, handleResponse?: (goalId: number) => void) =>
  requestAction('GOAL_UPSERT')(
    `goals${goal.id ? `/${goal.id}` : ''}`,
    goal.id ? 'PUT' : 'POST',
    goal,
    undefined,
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response.goalId) })

export const upsertBulkGoal = (goals: Goal[], handleResponse: () => void) =>
  requestAction('GOAL_BULK_UPSERT')(
    'goalsBulk',
    'POST',
    goals,
    undefined,
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse() })
